/** Scanner ticker universes — core (fast) vs full curated list. */

import {
  SECTOR_DASHBOARD_ETFS,
  SECTOR_TICKER_PLAYS,
  SECTOR_ROTATION_TICKER_MAP,
} from "./sectorRotation.js";

export const SCANNER_SECTOR_ETF = Object.fromEntries(
  SECTOR_DASHBOARD_ETFS.map((s) => [s.name, s.etf])
);

export const SCANNER_SECTOR_OPTIONS = ["All Sectors", ...SECTOR_DASHBOARD_ETFS.map((s) => s.name)];

export const SCANNER_ETF_CORE = [
  "SPY", "QQQ", "IWM", "DIA", "VTI", "VOO", "SOXX", "SMH",
  "XLK", "XLF", "XLE", "XLV", "XLP", "XLY", "XLI", "XLB", "XLU", "XLC",
  "GLD", "SLV", "TLT", "HYG", "XBI", "IBB", "ARKK",
];

/** Liquid rotation + ETF spine (~180–220 names). */
export function buildScannerCoreTickers() {
  const set = new Set(SCANNER_ETF_CORE);
  for (const list of Object.values(SECTOR_TICKER_PLAYS)) {
    for (const t of list) set.add(String(t).toUpperCase());
  }
  return [...set].sort();
}

export function getScannerThemeOptions(scannerUniverse) {
  return ["All Themes", ...Object.keys(scannerUniverse || {})];
}

export function filterTickersByTheme(tickers, themeName, scannerUniverse) {
  if (!themeName || themeName === "All Themes" || !scannerUniverse?.[themeName]) {
    return tickers;
  }
  const allow = new Set(scannerUniverse[themeName].map((s) => String(s).toUpperCase()));
  return tickers.filter((t) => allow.has(String(t).toUpperCase()));
}

export function filterTickersByRotationSector(tickers, sectorName) {
  if (!sectorName || sectorName === "All Sectors") return tickers;
  const etf = SCANNER_SECTOR_ETF[sectorName];
  if (!etf) return tickers;
  return tickers.filter((sym) => SECTOR_ROTATION_TICKER_MAP[sym] === etf);
}

/**
 * @param {'core'|'full'} mode
 * @param {string[]} fullUniverse deduped full list
 * @param {Record<string, string[]>} scannerUniverse theme map
 */
export function resolveScannerTickerList({
  mode = "core",
  theme = "All Themes",
  rotationSector = "All Sectors",
  fullUniverse = [],
  scannerUniverse = {},
}) {
  let list = mode === "full" ? [...fullUniverse] : buildScannerCoreTickers();
  list = filterTickersByRotationSector(list, rotationSector);
  list = filterTickersByTheme(list, theme, scannerUniverse);
  return [...new Set(list.map((s) => String(s).toUpperCase()))];
}

export const SCANNER_STALE_MS = 24 * 60 * 60 * 1000;

export function symbolsNeedingRescan(symbols, cachedResults = [], staleMs = SCANNER_STALE_MS) {
  const bySym = new Map(cachedResults.map((r) => [String(r.symbol).toUpperCase(), r]));
  const now = Date.now();
  return symbols.filter((sym) => {
    const hit = bySym.get(String(sym).toUpperCase());
    const ts = hit?.result?.scanTime;
    return ts == null || now - ts > staleMs;
  });
}
